// Webpack Imports
//import 'bootstrap';




( function ( $ ) {
	'use strict';

	// Focus Search if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( '#s' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );


	var swiper = new Swiper('.swiper-container-coverflow', {
		effect: 'coverflow',
		grabCursor: true,
		centeredSlides: true,
		loop: true,
		slidesPerView: 1,
		//spaceBetween: 50,
		coverflowEffect: {
			rotate: 0,
			stretch: -200,
			depth: 300,
			modifier: 1,
			slideShadows: true,
		},
		breakpoints: {
			1024: {
				slidesPerView: 2,
			}
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});

	var swiper2 = new Swiper('.swiper-container-carousel', {

		effect: 'flip',
		grabCursor: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});


	var $grid = $('.isotope-grid').isotope({
		// options
		itemSelector: '.grid-item',
		layoutMode: 'fitRows',
		percentPosition: true,
		fitRows: {
			gutter: '.gutter-sizer'
		}
	});

	// layout Isotope after each image loads
	$grid.imagesLoaded().progress( function() {
		$grid.isotope('layout');
	});


	// filter items on button click
	$('.isotope-filters').on( 'click', '.filter-link', function() {
		$('.filter-link').removeClass('active');
		var filterValue = $(this).attr('data-filter');
		var slug = filterValue.substring(1);
		var descText = $(this).data('desc');
		var descTextFormatted = '<p>' + descText.replace(/\n([ \t]*\n)+/g, '</p><p>')
			.replace('\n', '<br />') + '</p>';
		var desc = '<div class="term-description" style="text-align: center;">' + descTextFormatted + '</div>';
		$grid.isotope({ filter: filterValue });
		$(this).addClass('active');

		if (descText) {
			$('.text-swap').hide();
			if ($('.term-description').length){
				$('.term-description').html(descTextFormatted);
			}
			else{
				$('.text-swap').after(desc);
			}
			$('.term-description').show();
		}
		else{
			$('.text-swap').show();
			$('.term-description').hide();
		}
		//load taxonomy term into this .text-swap class section
	});



	$.fn.isVis = function(){

		var toScroll = $(this).offset().top - $(window).height();
		console.log($(this).offset().top);
		//console.log($(this).offset().top - $(window).height());
		var scrollTop = $(window).scrollTop();


		return (scrollTop >= toScroll);
	}



	$.fn.extend({
		isAtTop: function(){
			var $el = $(this);
			var elementOffset = $(this).offset().top;
			var scrollTop = $(window).scrollTop();
			var distance = Math.floor(elementOffset - scrollTop);
			//console.log(distance);
			if (distance < 10 && distance > -10){
				return $el;
			}
			else{
				return false;
			}
		}
	});



	$.wait = function( callback, seconds){
		return window.setTimeout( callback, seconds * 1000 );
	}

	if($('.section.history').length){
		$(window).on('scroll', function () {
			$('.timeline-slide:not(.active)').each(function(){
				if($(this).isAtTop()){
					var el = $(this).isAtTop();
					$('.timeline-slide').removeClass('active');
					$(el).addClass('active');
					var id = $(el).data('id');
					console.log(id + ' is at top');
					//find image
					$('.timeline-image').removeClass('active');
					var selector = '.timeline-image[data-id="' + id + '"]';
					console.log(selector);
					$('.timeline-image[data-id="' + id + '"]').addClass('active');
				}
			});

		});
	}

	$(document).ready(function() {
		$('.magnific-iframe').magnificPopup({type:'iframe'});

		$('button.navbar-toggler').unbind().click(function(){
			if ($('#navbar').hasClass('navbar-hide-desk')){
				setTimeout(
					function(){
						$('#navbar').removeClass('navbar-hide-desk');
					}, 400
				);
			}
			else{
				$('#navbar').addClass('navbar-hide-desk');
			}

		});



	});





}( jQuery ) );
